// Importing necessary libraries and components
/* eslint-disable import/extensions */
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import styles from "assets/jss/material-dashboard-react/components/businessForm";

// Hook to apply custom styles
const useStyles = makeStyles(styles);

// LongMenu component definition
function LongMenu(props) {
  const classes = useStyles(); // Applying custom styles
  const [anchorEl, setAnchorEl] = React.useState(null); // State to manage menu anchor
  const open = Boolean(anchorEl); // Boolean to check if the menu is open
  const { handleUpdateDBAModal } = props; // Destructuring props

  // Function to handle menu open
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  // Function to handle menu close
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {/* Icon button to trigger the menu */}
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>

      {/* Menu component */}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        {/* Menu item for JSON Data */}
        <MenuItem
          className={classes.dialogBoxDropDown}
          onClick={() => {
            handleUpdateDBAModal(); // Triggering the modal update function
            handleClose(); // Closing the menu
          }}
        >
          JSON Data
        </MenuItem>
      </Menu>
    </div>
  );
}

// Prop types for the LongMenu component
LongMenu.propTypes = {
};

LongMenu.defaultProps = {
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(LongMenu);
